import React from "react";
import { SectionTitle, AboutTab } from "../../components";
import Layout from "../../layouts/Layout";

const About = () => {
  return (
    <>
      <Layout title={"About"}>
        <div className="dg__market__data pt--130 pb--80">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  title={"About"}
                  text={` Benderimki.com site belongs to Next Generation company.

    Next Generation aims to produce solutions by using technology in the most efficient and effective way. It brings innovations and makes a difference with its expertise in the Internet. It is an indispensable principle for us to add real value to the society with the services we offer.`}
                />
                <AboutTab />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default About;
